import { DataPointWithValue } from '@src/types/DataPoint';
import { ReactElement } from 'react';

function LableValueRender(props: {
  xPosition: number;
  yPosition: number;
  dataPoints?: DataPointWithValue[];
  pointNames:
    | string[]
    | {
        pointName: string;
        label?: string;
        ignoreInLableValueRender?: boolean;
      }[];
}): ReactElement {
  const { xPosition, yPosition, dataPoints, pointNames } = props;

  // Check if dataPoints are defined
  if (!dataPoints || dataPoints.length === 0) {
    return (
      <g transform={`translate(${xPosition} ${yPosition})`}>
        <text
          x='25'
          y='20'
          fontSize='8'
          fill='white'
          stroke='white'
          strokeWidth='0.2'
          textAnchor='middle'
        >
          No data
        </text>
      </g>
    );
  }

  // Handle both string[] and object[] formats for pointNames
  const pointNamesArray = pointNames.map((point) =>
    typeof point === 'string' ? { pointName: point } : point,
  );

  // Match each pointName with its corresponding dataPoint
  // Filter out any data points that have "status" in their pointName
  const matchedDataPoints = pointNamesArray
    .map((pointConfig) => {
      const dataPoint = dataPoints.find(
        (dp) =>
          dp.pointName.toLowerCase() === pointConfig.pointName.toLowerCase(),
      );

      return dataPoint && !pointConfig.ignoreInLableValueRender
        ? {
            ...dataPoint,
            displayLabel: pointConfig.label || pointConfig.pointName,
          }
        : null;
    })
    .filter(Boolean);

  return (
    <g transform={`translate(${xPosition} ${yPosition})`}>
      {matchedDataPoints.map((dataPoint, index) => (
        <text
          key={index}
          x='0'
          y={20 + index * 15}
          fontSize='8'
          fill='white'
          stroke='white'
          strokeWidth='0.2'
          textAnchor='start'
        >
          <tspan>{dataPoint?.displayLabel}:</tspan>
          <tspan x='80'>{dataPoint?.value || 'N/A'}</tspan>
        </text>
      ))}
    </g>
  );
}

export default LableValueRender;
